import styled, { css } from 'styled-components';

import ToolTip from '../../molecules/ToolTipV2';
import SVGIcon from '../../atoms/SVGIcon';
import Heading from '../../atoms/Heading';
import NavButtonWithIcon from '../../molecules/NavButtonWithIcon';
import ThemeV2 from '../../../componentsV2/theme';
import { device } from '../../../constants/layout';

export const HomeDrawerWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 72px);
`;

export const TooltipWrapper = styled(ToolTip)`
  display: inline-flex;
  margin-left: 4px;
`;

export const TooltipContent = styled.div`
  width: 196px;
`;

export const HeadingWithoutMargin = styled(Heading)`
  margin: 0;
`;

export const Spacing = styled.div<{
  margin?: string;
  padding?: string;
  line?: boolean;
}>`
  width: 100%;
  border-bottom: ${({ line }) =>
    line ? `1px solid ${ThemeV2.palette.gray4}` : `unset`};
  padding: ${({ padding }) => (padding ? `${padding}` : `unset`)};
  margin: ${({ margin }) => (margin ? `${margin}` : `unset`)};
`;

export const NavButtonWithIconWrapper = styled(NavButtonWithIcon)`
  margin-top: 8px;
`;

export const StyledBetaIcon = styled(SVGIcon)`
  margin-left: 8px;
`;

export const DrawerTopContent = styled.div`
  padding: 24px 12px 0 12px;
  @media ${device.tabletV2} {
    padding: 16px 16px 0 16px;
  }
`;

export const DrawerBottomContent = styled.div<{
  isHoveredWhenCollapsed: boolean;
  onScroll: (...args: any[]) => any;
}>`
  padding: 16px 0 40px 0;
  overflow-x: hidden;

  ${({ isHoveredWhenCollapsed }) =>
    isHoveredWhenCollapsed &&
    css`
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04),
        0px 3px 4px rgba(0, 0, 0, 0.02), 0px 1px 5px rgba(0, 0, 0, 0.12);
      padding: 16px 16px 40px 0;
    `}

  @media (min-width: ${ThemeV2.breakPoints.md}) {
    height: 100%;
    overflow-y: auto;
  }
`;
